export default "__VITE_ASSET__CPBKlY2y__"